export default __webpack_public_path__ + "static/media/i207hk.9d3f85bb.webp";